import { useState } from 'react';

/**
 * Returns the same value on every render for the life of the component.
 *
 * Accepts either the value itself or, like useState, an initialiser function
 * that runs once on the first render. Pass an initialiser when the value is
 * expensive to build; a plain value argument is still evaluated by the caller
 * on every render even though only the first result is kept. A function kept
 * as the value must be wrapped in an initialiser: useStatic(() => onSelect).
 */
export function useStatic<T>(init: () => T): T;
export function useStatic<T>(staticValue: T): T;
export function useStatic<T>(staticValue: T | (() => T)): T {
  const [value] = useState(staticValue);
  return value;
}
